export default __webpack_public_path__ + "static/media/lahve_barva-min.a717bbd4.png";